import React from 'react';
import PropTypes from 'prop-types';

const Card = ({ className, children, ...props }) => {
  const classNames = ['card-wrapper', className].join(' ');

  return (
    <div className={classNames} {...props}>
      {children}
    </div>
  );
};

Card.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};
Card.defaultProps = {
  className: '',
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/Card.js